import { render, staticRenderFns } from "./List-Employees.vue?vue&type=template&id=a1506a7a"
import script from "./List-Employees.vue?vue&type=script&lang=js"
export * from "./List-Employees.vue?vue&type=script&lang=js"
import style0 from "./List-Employees.vue?vue&type=style&index=0&id=a1506a7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports